export const systemLabelConstants = {
    GET_SYSTEM_LABEL_REQUEST: 'GET_SYSTEM_LABEL_REQUEST',
    GET_SYSTEM_LABEL_SUCCESS: 'GET_SYSTEM_LABEL_SUCCESS',
    GET_SYSTEM_LABEL_FAILURE: 'GET_SYSTEM_LABEL_FAILURE',

    GET_SYSTEM_LABEL_GROUP_REQUEST: 'GET_SYSTEM_LABEL_GROUP_REQUEST',
    GET_SYSTEM_LABEL_GROUP_SUCCESS: 'GET_SYSTEM_LABEL_GROUP_SUCCESS',
    GET_SYSTEM_LABEL_GROUP_FAILURE: 'GET_SYSTEM_LABEL_GROUP_FAILURE',

    GET_ALL_SYSTEM_LABEL_GROUP_REQUEST: 'GET_ALL_SYSTEM_LABEL_GROUP_REQUEST',
    GET_ALL_SYSTEM_LABEL_GROUP_SUCCESS: 'GET_ALL_SYSTEM_LABEL_GROUP_SUCCESS',
    GET_ALL_SYSTEM_LABEL_GROUP_FAILURE: 'GET_ALL_SYSTEM_LABEL_GROUP_FAILURE',

    GET_SYSTEM_LABEL_DATA_REQUEST: 'GET_SYSTEM_LABEL_DATA_REQUEST',
    GET_SYSTEM_LABEL_DATA_SUCCESS: 'GET_SYSTEM_LABEL_DATA_SUCCESS',
    GET_SYSTEM_LABEL_DATA_FAILURE: 'GET_SYSTEM_LABEL_DATA_FAILURE',

    GET_ALL_LABEL_GROUPS_REQUEST: 'GET_ALL_LABEL_GROUPS_REQUEST',
    GET_ALL_LABEL_GROUPS_SUCCESS: 'GET_ALL_LABEL_GROUPS_SUCCESS',
    GET_ALL_LABEL_GROUPS_FAILURE: 'GET_ALL_LABEL_GROUPS_FAILURE',
    
    UPDATE_SYSTEM_LABEL_REQUEST: 'UPDATE_SYSTEM_LABEL_REQUEST',
    UPDATE_SYSTEM_LABEL_SUCCESS: 'UPDATE_SYSTEM_LABEL_SUCCESS',
    UPDATE_SYSTEM_LABEL_FAILURE: 'UPDATE_SYSTEM_LABEL_FAILURE',

    UPDATE_RANGE_SYSTEM_LABEL_REQUEST: 'UPDATE_RANGE_SYSTEM_LABEL_REQUEST',
    UPDATE_RANGE_SYSTEM_LABEL_SUCCESS: 'UPDATE_RANGE_SYSTEM_LABEL_SUCCESS',
    UPDATE_RANGE_SYSTEM_LABEL_FAILURE: 'UPDATE_RANGE_SYSTEM_LABEL_FAILURE',

    CREATE_SYSTEM_LABEL_REQUEST: 'CREATE_SYSTEM_LABEL_REQUEST',
    CREATE_SYSTEM_LABEL_SUCCESS: 'CREATE_SYSTEM_LABEL_SUCCESS',
    CREATE_SYSTEM_LABEL_FAILURE: 'CREATE_SYSTEM_LABEL_FAILURE',

    CREATE_LAYOUT_LABEL_REQUEST: 'CREATE_LAYOUT_LABEL_REQUEST',
    CREATE_LAYOUT_LABEL_SUCCESS: 'CREATE_LAYOUT_LABEL_SUCCESS',
    CREATE_LAYOUT_LABEL_FAILURE: 'CREATE_LAYOUT_LABEL_FAILURE',

    GET_LAYOUT_LABEL_GROUP_REQUEST: 'GET_LAYOUT_LABEL_GROUP_REQUEST',
    GET_LAYOUT_LABEL_GROUP_SUCCESS: 'GET_LAYOUT_LABEL_GROUP_SUCCESS',
    GET_LAYOUT_LABEL_GROUP_FAILURE: 'GET_LAYOUT_LABEL_GROUP_FAILURE',
    //and so on
};